import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {ErrorLayoutType} from 'common/constants';
import {SurveyId, SurveySettings} from 'common/models/survey';
import {merge} from 'lodash';
import {setErrorAction} from 'ui/store/system/actions/setError';
import getRequestError from 'ui/store/utils/getRequestError';
import withAbortRequest from 'ui/store/utils/withAbortRequest';
import {sdk} from 'ui/utils/sdk';

import {namespace} from '../constants';
import {AsyncThunkConfig, ReducerCallback} from '../survey.types';

interface PrepareSurvey {
    surveyId: SurveyId;
    iframe: boolean;
    key?: string;
}

const {preview} = window.YC;

const prepareSurveyAction = createAction<SurveySettings>(`${namespace}/prepareSurvey`);

export const reducerPrepareSurvey: ReducerCallback<SurveySettings> = (state, {payload}) =>
    merge(state, payload);

const prepareSurvey = createAsyncThunk<void, PrepareSurvey, AsyncThunkConfig<void>>(
    'prepareSurvey',
    ({surveyId, iframe, key}, {signal, dispatch}) => {
        const getForm = preview ? sdk.form.getPreview : sdk.form.getSurvey;
        return withAbortRequest(
            getForm({surveyId, key}).then((survey) => {
                if (survey.iframe && !iframe) {
                    throw {status: 404, code: ErrorLayoutType.OnlyInIframe};
                }
                dispatch(prepareSurveyAction(survey));
            }),
            signal,
        )
            .catch(getRequestError)
            .catch((status) => {
                dispatch(setErrorAction(status));
                return status;
            });
    },
);

export default prepareSurvey;
